<template>
  <!-- 外部布局新写的 -->
  <div
    id="rtabs"
    class="rtabs"
  >
    <ul class="rtabs-list clearfix">
      <li
        v-for="it in cfgs"
        :key="it.key"
        class="rtab"
        @click="tabClick(it)"
      >
        <span
          :class="[curComponent == it.key ? 'active' : '','t-name']"
        >{{ $t(it.name) }}</span>
      </li>
    </ul>
    <div class="rpanel-content">
      <component
        :is="curComponent"
        ref="tabitem"
        :refreshing="refreshing"
        @click="clickItem"
      ></component>
    </div>
  </div>
</template>
<script>
import oldRpanelComment from 'components/old/rpanel/comment/rpanel-comment.vue'
// 历史版本列表
import bsVerlist from 'components/business/verlist/index.vue'
import bsRpanelDetail from './rpanel-detail.vue'
// 基本文件信息
import bsFileInfo from './rpanel-fileinfo.vue'

export default {
  components: {
    oldRpanelComment, // 评论
    bsRpanelDetail, // 详情
    bsVerlist,
    bsFileInfo,
  },
  props: {
    value: {
      type: String,
      default: 'bsRpanelDetail',
    },
  },
  data() {
    return {
      refreshing: false,
    }
  },
  computed: {
    /**
     * 获取当前需要的组件
     */
    curComponent() {
      return this.$store.state.rpanelState.curTab || this.cfgs[0].key
    },
    /**
     * 当前路径类型
     */
    pathType() {
      return this.$store.state.curFileInfo.path_type
    },
    cfgs() {
      if (this.pathType === 'ent') {
        return [{
          key: 'bsRpanelDetail',
          name: '详情',
        }, {
          key: 'oldRpanelComment',
          name: '评论',
        }, {
          key: 'bsVerlist',
          name: '版本',
        }]
      }
      // 如果非企业空间
      return [{
        key: 'bsFileInfo',
        name: '详情',
      }, {
        key: 'oldRpanelComment',
        name: '评论',
      }, {
        key: 'bsVerlist',
        name: '版本',
      }]
    },
  },
  methods: {
    /**
       * 历史版本列表点击事件，用于预览历史版本预览
     */
    clickItem(d) {
      this.$emit('clickItem', d)
    },
    tabClick(da) {
      this.$store.commit('CHANGE_RIGHT_TAB', da.key)
    },
    refresh() {
      this.refreshing = true
      this.$nextTick(() => {
        this.refreshing = false
      })
    },
  },
}
</script>
<style lang="less" scoped>
  .rtabs {
    background: #FFFFFF;
    border: 1px solid #E8EBEF;
    height: 100%;
    .rpanel-content {
      height: calc(~"100% - 43px");
    }
    .rtabs-list {
      border-bottom: 1px solid #e8ebef;
      line-height: 42px;
      height: 43px;
      padding: 0 24px;
      .rtab {
        float: left;
        margin-right: 24px;
        box-sizing: border-box;
        list-style: none;
        text-align: center;
        cursor: pointer;
      }
      .t-name {
        font-size: 14px;
        color: #282E3D;
      }
      .active {
        display: block;
        width: 100%;
        color: #2c7df1;
        border-bottom: #2c7df1 solid 2px;
      }
    }
  }
</style>
